import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AnnouncementBar from "./AnnouncementBar";

export default function Layout() {
  const loc = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [loc.pathname]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col">
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1 pt-24 md:pt-28">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
